import React, { useCallback } from 'react';

import { Panel } from '@atlaskit/navigation-system/layout/panel';
import { PanelSplitter } from '@atlaskit/navigation-system/layout/panel-splitter';
import { useCurrentPreviewPanel } from '@atlassian/preview-panels-api/use-current-preview-panel';
import { usePreviewPanelsActions } from '@atlassian/preview-panels-api/use-preview-panel-actions';

import { AggRelayEnvironmentProvider } from '@townsquare/relay-utils/agg-environment';

type Props = {
	/**
	 * Minimum width the preview panel can open at. The preview-panels-api already
	 * scales the opening width with the viewport; this only raises the floor.
	 */
	minDefaultWidth?: number;
};

export const PreviewPanelContainer = ({ minDefaultWidth }: Props): React.JSX.Element | null => {
	const panel = useCurrentPreviewPanel();
	const { setPanelWidth } = usePreviewPanelsActions();

	const onResizeEnd = useCallback(
		({ finalWidth }: { finalWidth: number }) => {
			setPanelWidth(finalWidth);
		},
		[setPanelWidth],
	);

	if (!panel) {
		return null;
	}

	const { content: PanelContent, width } = panel;

	const defaultWidth = minDefaultWidth ? Math.max(width, minDefaultWidth) : width;

	return (
		<AggRelayEnvironmentProvider>
			<Panel defaultWidth={defaultWidth}>
				<PanelSplitter label="Resize preview panel" onResizeEnd={onResizeEnd} />
				<PanelContent />
			</Panel>
		</AggRelayEnvironmentProvider>
	);
};
